import { Component, OnInit } from '@angular/core';
import { Tier1 } from 'src/app/models/obs/tier1';
import { Message } from 'src/app/models/message';
import { Tier1Service } from 'src/app/services/obs/tier1.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { Tier3 } from 'src/app/models/obs/tier3';
import { Tematic } from 'src/app/models/obs/tematic';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { ActivatedRoute } from '@angular/router';
import { AccessService } from 'src/app/services/access.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { T3RecordService } from 'src/app/services/obs/t3-record.service';

@Component({
  selector: 'app-t1-r-list',
  templateUrl: './t1-r-list.component.html',
  styleUrl: './t1-r-list.component.scss'
})
export class T1RListComponent implements OnInit {

  idTier1: number;
  idriesgo: number = 6;
  result: any;
  t1: Tier1;
  tematic: Tematic[];
  t3: Tier3[];
  idtier3Selected: string = null;
  t3Selected: Tier3;
  msg: Message = null;
  selectedItem: any;
  selectedT1: string = null;
  tier3Versions: Tier3[] = [];

  filteredData: any[] = [];
  searchTerm: string = '';

  filters = {
    searchText: '',
    estado: null as boolean | null,
    tematica: ''
  };

  constructor(
    private t1S: Tier1Service,
    private tematicS: TematicService,
    private t3S: Tier3Service,
    private t3rs: T3RecordService,
    private activedRoute: ActivatedRoute,
    private accesService: AccessService,
    private ts: TokenStorageService
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    /* this.selectedT1 = "6"; */
    this.get4EventType(2)
    this.getTematics();
    /* this.getT34t1("6"); */
    this.loadSelectedRisk();
    this.getPermission();
    this.getPermissionLog();
  }
  //bandera que controla la creacion de contenido
  accessMP: boolean = false
  //bandera que controla la eliminacion de contenido
  accessME: boolean = false
  //bandera que controla la eliminacion de contenido
  accessMD: boolean = false
  //bandera que controla la creacion de reportes territoriales
  createReportT: boolean = false;
  //bandera que controla la creacion de reportes sectoriales
  createReportS: boolean = false;
  //bandera que controla la creacion listado y documento
  createDoc: boolean = false;
  //bandera que controla la creacion de grafico de dispersion
  createGD: boolean = false;
  inf = {}
  allT3: Tier3[] = [];
  viewingClones: boolean = false;
  accessLog: boolean = false;

  loadSelectedRisk() {
    const savedRiskId = sessionStorage.getItem('selectedRiskId');
    this.changeRisk(savedRiskId ? savedRiskId : "6");
  }

  getPermission() {
    this.inf['userId'] = this.ts.getUser().id;
    this.inf['accessId'] = 2;//riesgo
    const data = this.inf;

    this.accesService.getPermissionUser(data).subscribe({
      next: res => {
        this.accessMP = res['result'].create;
        this.accessME = res['result'].edit;
        this.accessMD = res['result'].del
        this.createReportT = res['result'].createReportT;
        this.createReportS = res['result'].createReportS;
        this.createDoc = res['result'].createDoc;
        this.createGD = res['result'].createGD;
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  getPermissionLog() {
    this.inf['userId'] = this.ts.getUser().id;
    this.inf['accessId'] = 12;
    const data = this.inf;
    this.accesService.getPermissionUser(data).subscribe({
      next: res => {
        this.accessLog = res['result'] ? true : false;
      },
      error: err => { this.msg = err; }
    });
  }

  // Metodo de filtro
  applyFilter(): void {
    const listToFilter = this.viewingClones ? this.tier3Versions : this.t3;
    this.filteredData = listToFilter.filter(obj =>
      // Filtro compartido para nombreLargo y codigo
      (this.filters.searchText
        ? obj.longtitle.toLowerCase().includes(this.filters.searchText.toLowerCase()) ||
        obj.code.toLowerCase().includes(this.filters.searchText.toLowerCase())
        : true) &&
      // Filtro select para estado
      (this.filters.estado !== null ? obj.status == this.filters.estado : true) &&
      // Filtro select para tematica
      (this.filters.tematica ? obj.tematic == this.filters.tematica : true)
    );
  }

  getT34t1(id: string) {
    this.t3S.get4t1adm(id).subscribe({
      next: res => {
        this.allT3 = res['data'];
        this.result = res
        this.t3 = this.allT3;
        this.orderForCode();
        this.filteredData = [...this.t3];
        this.applyFilter();
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  cloneElement(id: string) {
    const confirmClone = window.confirm("La ficha actual será suspendida temporalmente mientras se realiza la edición. ¿Desea continuar?");
    if (!confirmClone) return;
    this.t3rs.cloneTier3(id).subscribe({
      next: res => {
        window.alert(res['message']);
        this.viewingClones = false;
        this.loadSelectedRisk();
      },
      error: err => {
        console.error("Error al desactivar el elemento:", err);
        window.alert("Hubo un error al intentar desactivar el elemento: " + err.message);
      }
    });
  }

  loadVersions(tier3: Tier3) {
    this.t3rs.getT3ByCodeAdm(tier3.code).subscribe({
      next: res => {
        this.tier3Versions = res['data'];
        if (this.tier3Versions.length === 0) {
          window.alert("La ficha no tiene versiones previas.");
          return;
        }
        this.viewingClones = true;
        this.filters = { searchText: '', estado: null, tematica: '' };
        this.applyFilter();
      },
      error: err => {
        console.log("error : ", err);
      }
    }
    );
  }

  goBackToGeneralList() {
    this.orderForCode();
    this.viewingClones = false;
    this.filters = { searchText: '', estado: null, tematica: '' };
    this.applyFilter();
  }

  setAsInactiveVersion(id: number) {
    const confirmApproval = window.confirm("¿Está seguro de que desea desactivar esta ficha?");

    if (!confirmApproval) return;

    this.t3S.setInactiveVersion(id).subscribe({
      next: (res) => {
        window.alert(res['message']);
        this.viewingClones = false;
        this.loadSelectedRisk();
      },
      error: (err) => {
        console.error("Error al inhabilitar la ficha:", err);
        window.alert("Hubo un error al intentar inhabilitar la ficha.");
      },
    });
  }

  orderForCode() {
    if (this.t3.length > 0) {
      this.t3.sort((a, b) => {
        const [prefixA, numberA, yearA] = this.extractParts(a.code);
        const [prefixB, numberB, yearB] = this.extractParts(b.code);

        if (prefixA < prefixB) return -1;
        if (prefixA > prefixB) return 1;

        if (numberA !== numberB) return numberA - numberB;

        return yearA - yearB;
      });

      const t3_actives = this.t3.filter(t => t.status == true);
      const t3_inactives = this.t3.filter(t => t.status == false);
      this.t3 = [...t3_actives, ...t3_inactives];
    }
  }

  extractParts(code: string): [string, number, number] {
    const prefixMatch = code.match(/^[a-z]+/i);
    const prefix = prefixMatch ? prefixMatch[0] : '';
    const numberMatch = code.match(/\d+/);
    const number = numberMatch ? parseInt(numberMatch[0], 10) : Infinity;
    const yearMatch = code.match(/_(\d{4})$/);
    const year = yearMatch ? parseInt(yearMatch[1], 10) : Infinity;
    return [prefix, number, year];
  }

  getTematics() {
    this.tematicS.getAll().subscribe({
      next: res => {
        this.result = res
        this.tematic = res['data'];
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  get4EventType(id: number) {
    this.t1S.getByEvent(id).subscribe(
      res => {
        this.result = res
        this.t1 = res['data'];
      },
      err => {
        this.msg = err;
      });
  }

  changeRisk(id: string) {
    this.idTier1 = Number(id);
    this.t3 = [];
    this.selectedItem = id;
    sessionStorage.setItem('selectedRiskId', id);
    this.getT34t1(id);
    this.viewingClones = false;
  }
  //No se usara aun 
  deleteRisk(id: string, protect: boolean) {
    if (protect) {
      window.alert("No puede eliminar una ficha publicada!. Esta acción esta configurada para eliminar clones defectuosos.");
      return;
    }
    const confirmApproval = window.confirm("¿Está seguro de que desea ELIMINAR PERMANENTEMENTE esta ficha?");

    if (!confirmApproval) return;

    this.t3S.deleteT3Casc(id).subscribe(
      res => {
        window.alert(res['message']);
        this.viewingClones = false;
        this.loadSelectedRisk();
      },
      err => {
        console.error("Error al eliminar la ficha:", err);
        window.alert("Hubo un error al intentar eliminar la versión de la ficha.");
      }
    );
  }

  setView(word: string) {    
    sessionStorage.setItem('isEye', word);
  }

}
